// Average glyph width of the 14px body font, rounded up so a long name rarely truncates.
const AVERAGE_CHARACTER_WIDTH_PX = 8;
// The input padding plus the clear and dropdown-arrow icons.
const CONTROL_CHROME_PX = 72;
const MIN_WIDTH_PX = 200;
const MAX_WIDTH_PX = 400;

export default function getMappingSelectWidthPx(options: { name: string }[]) {
  const longestNameLength = Math.max(0, ...options.map((option) => option.name.length));
  const widthForLongestName =
    longestNameLength * AVERAGE_CHARACTER_WIDTH_PX + CONTROL_CHROME_PX;

  return Math.min(MAX_WIDTH_PX, Math.max(MIN_WIDTH_PX, widthForLongestName));
}
